import { useSelector } from 'react-redux';
import { CONNECTION_CATEGORY_TEMPLATIZED_EMAIL_SCRIPT } from 'js/constants/connectionCategories';

export function useProbeFile({
  filePath,
  resourceId,
  resourceType,
  credentialId,
  connectionCategory,
}) {
  const shouldFetchOnResource =
    !!connectionCategory && connectionCategory === CONNECTION_CATEGORY_TEMPLATIZED_EMAIL_SCRIPT;
  let probe = useSelector((state: any) => state.probe);
  if (shouldFetchOnResource === true) {
    if (resourceId !== null && resourceType !== null) {
      let dataId = `${resourceType}_${resourceId}`;
      if (probe[dataId] && filePath && probe[dataId].files[filePath]) {
        return probe[dataId].files[filePath];
      }
    }
  } else {
    return probe?.[credentialId]?.files?.[filePath];
  }
}
